<template>
  <v-dialog
    v-model="dialog"
    width="500"
    height="350"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        :title="title"
        :disabled="disabled"
        v-on="on"
      >
        <v-icon>
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        {{ title }}
        <v-spacer />
        <v-btn
          icon
          :title="$t('dialog.close')"
          @click="dialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              :value="item.name"
              :label="$t('mediacenter.filename')"
              readonly
            />
          </v-col>
        </v-row>
        <v-row v-if="item.type == 'file' && item.size !== ''">
          <v-col cols="4">
            <v-text-field
              :value="size | formatSize"
              :label="$t('mediacenter.size')"
              readonly
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              :value="item.mime"
              :label="$t('mediacenter.mime')"
              readonly
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              :value="item.ext"
              :label="$t('mediacenter.extension')"
              readonly
            />
          </v-col>
        </v-row>
        <v-row v-if="item.type == 'file' && dimensions !== ''">
          <v-col cols="12">
            <v-text-field
              :value="dimensions"
              :label="$t('mediacenter.dimensions')"
              readonly
            />
          </v-col>
        </v-row>
        <v-row v-if="item.type == 'file' && modified !== ''">
          <v-col cols="12">
            <v-text-field
              :value="modified"
              :label="$t('mediacenter.modified')"
              readonly
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// Libs
import moment from "moment";

export default {
  filters: {
    formatSize: function (size) {
      if (size > 1024 * 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024 / 1024).toFixed(1) + " To";
      } else if (size > 1024 * 1024 * 1024) {
        return (size / 1024 / 1024 / 1024).toFixed(1) + " Go";
      } else if (size > 1024 * 1024) {
        return (size / 1024 / 1024).toFixed(1) + " Mo";
      } else if (size > 1024) {
        return (size / 1024).toFixed(1) + " Ko";
      } else if (size > 0) {
        return size.toFixed(1) + " octets";
      }
      return " octet";
    },
  },
  props: {
    icon: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      model: "",
    };
  },
  computed: {
    dimensions: {
      get: function () {
        if (this.item.width > 0 && this.item.height > 0) {
          return this.item.width + " x " + this.item.height + " px";
        } else {
          return "";
        }
      },
    },
    modified: {
      get: function () {
        if (this.item.path !== undefined) {
          moment.locale(this.$i18n.locale);
          return moment(this.item.date).format("LLLL");
        } else {
          return "";
        }
      },
    },
    size: {
      get: function () {
        if (this.item.path !== undefined) {
          return this.item.size;
        } else {
          return "";
        }
      },
    },
  },
};
</script>

<style></style>
